module.exports = __webpack_public_path__ + "media/images/views/candidate/request/wh-block-a30230153a6e4b2183081c3d21964c44.png";